import { render, staticRenderFns } from "./unlockedExperts.vue?vue&type=template&id=95953058&scoped=true"
import script from "./unlockedExperts.vue?vue&type=script&lang=js"
export * from "./unlockedExperts.vue?vue&type=script&lang=js"
import style0 from "./unlockedExperts.vue?vue&type=style&index=0&id=95953058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95953058",
  null
  
)

export default component.exports